import { createSelector } from 'reselect';

const entrySelector = (state, { id, contentType }) => state[contentType][id];

export default contentType => createSelector(
  state => state[contentType],
  state => state,
  (
    items,
    state,
  ) =>
    Object.keys(items).map(itemId =>
      entrySelector(state, { id: itemId, contentType }),
    ),
);



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/factories/selectors.js